import React from 'react';
import { CreateBase, useRedirect, useResourceContext } from 'react-admin';
import SimpleFormCustom from '../../Components/Form/SimpleFormCustom';
import CreateHeader from '../../Components/Form/CreateHeader';
import Form from './Form';

const transformCreate = (data) => {
  console.log('data transform', data);
  const currencies = data.currencies?.filter(item => item.enabled !== false);
  return ({ ...data, currencies });
};
const Create = () => {
  const redirect = useRedirect();
  const resource = useResourceContext();

  const goBack = () => {
    redirect(`/${resource}`);
  };

  return (
    <CreateBase mutationMode='optimistic' transform={transformCreate}>
      <SimpleFormCustom sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} header={<CreateHeader goBack={goBack} label='Nuevo Comercio' />}>
        <Form isCreate />
      </SimpleFormCustom>
    </CreateBase>
  );
};

export default Create;